import { render, staticRenderFns } from "./NuevaCancha.vue?vue&type=template&id=4c35a226"
import script from "./NuevaCancha.vue?vue&type=script&lang=js"
export * from "./NuevaCancha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports